import React from 'react';
import styled from '@emotion/styled';

const AsteriskStyle = styled('span')`
    font-size: 22px;
    margin-left: 5px;
    vertical-align: middle;
    line-height: 1px;
`;

function RequiredAsterisk() {
    return <AsteriskStyle className="text-danger"> * </AsteriskStyle>;
}

export default RequiredAsterisk;
